// Product page: thumbnail clicks swap the main image; the quantity stepper never goes below 1.
(function () {
  'use strict';

  document.querySelectorAll('[data-product-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = document.documentElement.dataset.motion !== 'none' && !reduce;
    var FADE_MS = 180;
    var pending = null;

    function swap(thumb) {
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.classList.contains('is-active')) return;
        if (animate) {
          // Crossfade: fade out, swap once decoded, fade back in.
          main.classList.add('is-fading');
          // Rapid clicks: cancel the previous swap so the image always matches the last thumb.
          clearTimeout(pending);
          pending = setTimeout(function () {
            swap(thumb);
            var shown = main.decode ? main.decode().catch(function () {}) : Promise.resolve();
            shown.then(function () { main.classList.remove('is-fading'); });
          }, FADE_MS);
        } else {
          swap(thumb);
        }
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });

  document.querySelectorAll('[data-quantity]').forEach(function (root) {
    var input = root.querySelector('input');
    root.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = (parseInt(input.value, 10) || 1) + Number(button.dataset.quantityStep);
        input.value = Math.max(1, next);
      });
    });
  });
})();
